/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ home: NonNullable<unknown>, away: NonNullable<unknown> }} Push_Match_Start_TitleInputs */

const th_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} พบ ${i?.away}`)
};

const en_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} vs ${i?.away}`)
};

const ja_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} 対 ${i?.away}`)
};

const zh_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} 对阵 ${i?.away}`)
};

const es_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} contra ${i?.away}`)
};

const pt_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} x ${i?.away}`)
};

const id_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} lawan ${i?.away}`)
};

const fr_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} contre ${i?.away}`)
};

const tl_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} laban sa ${i?.away}`)
};

const vi_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} gặp ${i?.away}`)
};

const ko_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} 대 ${i?.away}`)
};

const de_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} gegen ${i?.away}`)
};

const ru_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} — ${i?.away}`)
};

const tr_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} – ${i?.away}`)
};

const it_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} contro ${i?.away}`)
};

const pl_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} – ${i?.away}`)
};

const uk_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} — ${i?.away}`)
};

const hi_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} बनाम ${i?.away}`)
};

const ar_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ضد ${i?.away}`)
};

const ms_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} lawan ${i?.away}`)
};

const bn_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} বনাম ${i?.away}`)
};

const zh_tw2_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} 對 ${i?.away}`)
};

const zh_hk2_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} 對 ${i?.away}`)
};

const ur_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} بمقابلہ ${i?.away}`)
};

const fa_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} مقابل ${i?.away}`)
};

const sw_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} dhidi ya ${i?.away}`)
};

const nl_push_match_start_title = /** @type {(inputs: Push_Match_Start_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} tegen ${i?.away}`)
};

/**
* | output |
* | --- |
* | "{home} vs {away}" |
*
* @param {Push_Match_Start_TitleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_match_start_title = /** @type {((inputs: Push_Match_Start_TitleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Match_Start_TitleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_match_start_title(inputs)
	if (locale === "ja") return ja_push_match_start_title(inputs)
	if (locale === "zh") return zh_push_match_start_title(inputs)
	if (locale === "es") return es_push_match_start_title(inputs)
	if (locale === "pt") return pt_push_match_start_title(inputs)
	if (locale === "id") return id_push_match_start_title(inputs)
	if (locale === "fr") return fr_push_match_start_title(inputs)
	if (locale === "tl") return tl_push_match_start_title(inputs)
	if (locale === "vi") return vi_push_match_start_title(inputs)
	if (locale === "ko") return ko_push_match_start_title(inputs)
	if (locale === "de") return de_push_match_start_title(inputs)
	if (locale === "ru") return ru_push_match_start_title(inputs)
	if (locale === "tr") return tr_push_match_start_title(inputs)
	if (locale === "it") return it_push_match_start_title(inputs)
	if (locale === "pl") return pl_push_match_start_title(inputs)
	if (locale === "uk") return uk_push_match_start_title(inputs)
	if (locale === "hi") return hi_push_match_start_title(inputs)
	if (locale === "ar") return ar_push_match_start_title(inputs)
	if (locale === "ms") return ms_push_match_start_title(inputs)
	if (locale === "bn") return bn_push_match_start_title(inputs)
	if (locale === "zh-TW") return zh_tw2_push_match_start_title(inputs)
	if (locale === "zh-HK") return zh_hk2_push_match_start_title(inputs)
	if (locale === "ur") return ur_push_match_start_title(inputs)
	if (locale === "fa") return fa_push_match_start_title(inputs)
	if (locale === "sw") return sw_push_match_start_title(inputs)
	if (locale === "nl") return nl_push_match_start_title(inputs)
	return en_push_match_start_title(inputs)
});